
function HostExperience() {
  return (
    <>
    <section className="ser_v_araeea allpages what_experience">
     <div className="container">
	   <div className="abt_pgs_areea boths">
	     <h2>Add your online profiles</h2>
		 <p>We’ll review your profiles and may suggest content and photos to improve your listing, Guests won’t see these links</p>
	   </div>	 
	   <div className="ads_profiles">
	    <div className="ad_mg_prff">
		 <img src="" alt="" />
		</div>
		<a href="javascript:void(0);" className="linksads">Add Profile</a>
	   </div>
	 </div>
	</section> 
    </>
  )
}

export default HostExperience